import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import useStyles from './styles';

import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Button from '@mui/material/Button';
import { PLAYLIST_CONFIG_CDN } from '../../../../../../../core/constants';
import { stringToSha256 } from '../../../../../../../utilities/helpers';
import { Paper, TableContainer } from '@mui/material';

import { TableRow, TableBody, TableCell, TableHead, TablePagination } from '@mui/material';
import { PLAYLIST_MODES } from '../../../../../../../core/constants';
import { getVideoCtaDetails } from '../../../../../../../utilities/pageLevelVideoCta';

export default function CustomDropdownTable(props) {
	const classes = useStyles();

	const {
		headRow,
		contentRows,
		handlePlaylistConfigSinglePageSync,
		siteId,
		playlistConfigMode,
		handlePlaylistConfigBulkPageSync,
		setPlaylistConfigMode,
		setPlaylistConfigPage
	} = props;

	const [tablePage, setTablePage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const handleChangePage = (event, newPage) => {
		setTablePage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setTablePage(0);
	};

	const handleUpdateConfigButtonClick = () => {
		if (playlistConfigMode === PLAYLIST_MODES.SITE_LEVEL_CREATE_PAGE_VIDEOS) {
			setPlaylistConfigMode(PLAYLIST_MODES.CREATE_PAGE_VIDEOS);
		} else {
			setPlaylistConfigMode(PLAYLIST_MODES.UPDATE_PAGE_VIDEOS);
		}
	};
	const rows = contentRows.map((row) => {
		return {
			url: row.url,
			activeVideos: row.activeVideos,
			videos: row.videos
		};
	});

	return (
		<Paper style={{ padding: '3.5rem 0' }}>
			<Box className={classes.buttonWrapper}>
				<Button variant="contained" onClick={() => handlePlaylistConfigBulkPageSync()}>
					Bulk Sync
				</Button>
				<Button variant="contained" onClick={handleUpdateConfigButtonClick}>
					Update Config
				</Button>
			</Box>
			<TableContainer>
				<Table aria-label="collapsible table">
					<TableHead>
						<TableRow>
							<TableCell />
							{headRow.map((heading, index) => {
								return (
									<TableCell key={index}>
										<Typography variant="p" fontWeight="bold" className={classes.heading}>
											{heading}
										</Typography>
									</TableCell>
								);
							})}
						</TableRow>
					</TableHead>
					<TableBody>
						{rows
							.slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage)
							.map((row, index) => (
								<Row
									key={index}
									index={index}
									siteId={siteId}
									row={row}
									handlePlaylistConfigSinglePageSync={handlePlaylistConfigSinglePageSync}
									setPlaylistConfigPage={setPlaylistConfigPage}
									setPlaylistConfigMode={setPlaylistConfigMode}
								/>
							))}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[10, 25, 100]}
				component="div"
				count={rows.length}
				rowsPerPage={rowsPerPage}
				page={tablePage}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</Paper>
	);
}

function Row(props) {
	const { row } = props;
	const classes = useStyles();

	// State to manage the open/close state of the collapsible row
	const [open, setOpen] = useState(false);

	// State to store the generated CDN URL
	const [cdnUrl, setCDNUrl] = useState('');

	useEffect(() => {
		/**
		 * Generates the CDN URL for the given URL.
		 * We SHA-256 the page url and generated hash is appended to
		 * our set cdn url
		 * @returns {Promise<string>} - Generated CDN URL.
		 */
		generateCDNUrl()
			.then((url) => {
				setCDNUrl(url);
			})
			.catch((error) => {
				console.error('Error generating CDN URL:', error);
			});
	});

	const {
		index,
		handlePlaylistConfigSinglePageSync,
		siteId,
		setPlaylistConfigPage,
		setPlaylistConfigMode
	} = props;

	const generateCDNUrl = async () => {
		const hash = await stringToSha256(row.url);
		return `${PLAYLIST_CONFIG_CDN}/${siteId}/instream/content/playlist/${hash}.json`;
	};

	const handleEditPage = () => {
		setPlaylistConfigPage(index + 1);
		setPlaylistConfigMode(PLAYLIST_MODES.UPDATE_PAGE_VIDEOS);
	};

	return (
		<>
			<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
				<TableCell>
					<IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
						{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</TableCell>

				<TableCell sx={{ maxWidth: '15rem', overflowWrap: 'break-word' }}>{row.url}</TableCell>
				<TableCell>{row.activeVideos}</TableCell>
				<TableCell>
					<Button variant="contained" onClick={() => handlePlaylistConfigSinglePageSync(row.url)}>
						Sync Page Videos
					</Button>
				</TableCell>
				<TableCell>
					<a href={cdnUrl} target="_blank">
						<Button variant="contained">CDN Url</Button>{' '}
					</a>
				</TableCell>
				<TableCell>
					<Button variant="contained" onClick={handleEditPage}>
						Edit Page
					</Button>{' '}
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box sx={{ margin: 1 }}>
							<Table size="large" aria-label="purchases">
								<TableHead>
									<TableRow>
										<TableCell>
											{' '}
											<Typography variant="p" fontWeight="bold" className={classes.subHeading}>
												Video Url
											</Typography>
										</TableCell>
										<TableCell>
											<Typography variant="p" fontWeight="bold" className={classes.subHeading}>
												Type
											</Typography>
										</TableCell>
										<TableCell align="right">
											<Typography variant="p" fontWeight="bold" className={classes.subHeading}>
												Number Of Times
											</Typography>
										</TableCell>
										<TableCell align="right">
											<TableCell align="right">
												<Typography variant="p" fontWeight="bold" className={classes.subHeading}>
													Thumbnail
												</Typography>
											</TableCell>
										</TableCell>
										<TableCell align="right">
											<TableCell align="right">
												<Typography variant="p" fontWeight="bold" className={classes.subHeading}>
													Description
												</Typography>
											</TableCell>
										</TableCell>
										<TableCell>
											<Typography fontWeight="bold" className={classes.subHeading}>
												CTA Text
											</Typography>
										</TableCell>
										<TableCell>
											<Typography fontWeight="bold" className={classes.subHeading}>
												CTA URL
											</Typography>
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{row &&
										row.videos &&
										row.videos.map((content, index) => (
											<TableRow key={index}>
												<TableCell
													align="left"
													sx={{ maxWidth: '20rem', overflowWrap: 'break-word' }}
												>
													{content.videoUrl}
												</TableCell>
												<TableCell
													align="left"
													sx={{ maxWidth: '10rem', overflowWrap: 'break-word' }}
												>
													{content.videoType}
												</TableCell>
												<TableCell
													align="right"
													sx={{ maxWidth: '5rem', overflowWrap: 'break-word' }}
												>
													{content.numberOfTimes}
												</TableCell>
												<TableCell
													sx={{ maxWidth: '20rem', overflowWrap: 'break-word' }}
													align="right"
												>
													{content.thumbnail}
												</TableCell>
												<TableCell
													align="right"
													sx={{ maxWidth: '20rem', overflowWrap: 'break-word' }}
												>
													{content.description}
												</TableCell>
												<TableCell>
													{getVideoCtaDetails(content).ctaText || '—'}
												</TableCell>
												<TableCell sx={{ maxWidth: '20rem', overflowWrap: 'break-word' }}>
													{getVideoCtaDetails(content).ctaUrl || '—'}
												</TableCell>
											</TableRow>
										))}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}
